//Slab rate
export const FETCH_SETTINGS_MWRC_SLAB_RATE_INIT_ACTION =
  "FETCH_SETTINGS_MWRC_SLAB_RATE_INIT_ACTION";
export const FETCH_SETTINGS_MWRC_SLAB_RATE_SUCCESS_ACTION =
  FETCH_SETTINGS_MWRC_SLAB_RATE_INIT_ACTION + "_SUCCESS";
export const FETCH_SETTINGS_MWRC_SLAB_RATE_FAIL_ACTION =
  FETCH_SETTINGS_MWRC_SLAB_RATE_INIT_ACTION + "_ERROR";

//fixed monthly charge
export const FETCH_SETTINGS_MWRC_FIXED_MONTHLY_CHARGE_INIT_ACTION =
  "FETCH_SETTINGS_MWRC_FIXED_MONTHLY_CHARGE_INIT_ACTION";
export const FETCH_SETTINGS_MWRC_FIXED_MONTHLY_CHARGE_SUCCESS_ACTION =
  FETCH_SETTINGS_MWRC_FIXED_MONTHLY_CHARGE_INIT_ACTION + "_SUCCESS";
export const FETCH_SETTINGS_MWRC_FIXED_MONTHLY_CHARGE_FAIL_ACTION =
  FETCH_SETTINGS_MWRC_FIXED_MONTHLY_CHARGE_INIT_ACTION + "_ERROR";

//fixed monthly charge edit
export const UPDATE_SETTINGS_MWRC_FIXED_MONTHLY_CHARGE_INIT_ACTION =
  "UPDATE_SETTINGS_MWRC_FIXED_MONTHLY_CHARGE_INIT_ACTION";
export const UPDATE_SETTINGS_MWRC_FIXED_MONTHLY_CHARGE_SUCCESS_ACTION =
  UPDATE_SETTINGS_MWRC_FIXED_MONTHLY_CHARGE_INIT_ACTION + "_SUCCESS";
export const UPDATE_SETTINGS_MWRC_FIXED_MONTHLY_CHARGE_FAIL_ACTION =
  UPDATE_SETTINGS_MWRC_FIXED_MONTHLY_CHARGE_INIT_ACTION + "_ERROR";

//fetchAdjustments
export const FETCH_SETTINGS_MWRC_ADJUSTMENTS_INIT_ACTION =
  "FETCH_SETTINGS_MWRC_ADJUSTMENTS_INIT_ACTION";
export const FETCH_SETTINGS_MWRC_ADJUSTMENTS_SUCCESS_ACTION =
  FETCH_SETTINGS_MWRC_ADJUSTMENTS_INIT_ACTION + "_SUCCESS";
export const FETCH_SETTINGS_MWRC_ADJUSTMENTS_FAIL_ACTION =
  FETCH_SETTINGS_MWRC_ADJUSTMENTS_INIT_ACTION + "_ERROR";

//AddAjustment
export const ADD_SETTINGS_MWRC_ADJUSTMENTS_INIT_ACTION =
  "ADD_SETTINGS_MWRC_ADJUSTMENTS_INIT_ACTION";
export const ADD_SETTINGS_MWRC_ADJUSTMENTS_SUCCESS_ACTION =
  ADD_SETTINGS_MWRC_ADJUSTMENTS_INIT_ACTION + "_SUCCESS";
export const ADD_SETTINGS_MWRC_ADJUSTMENTS_FAIL_ACTION =
  ADD_SETTINGS_MWRC_ADJUSTMENTS_INIT_ACTION + "_ERROR";

//get apartment for Quotanotset
export const FETCH_SETTINGS_QUOTANOTSET_TABLE_INIT_ACTION =
  "FETCH_SETTINGS_QUOTANOTSET_TABLE_INIT_ACTION";
export const FETCH_SETTINGS_QUOTANOTSET_TABLE_SUCCESS_ACTION =
  FETCH_SETTINGS_QUOTANOTSET_TABLE_INIT_ACTION + "_SUCCESS";
export const FETCH_SETTINGS_QUOTANOTSET_TABLE_FAIL_ACTION =
  FETCH_SETTINGS_QUOTANOTSET_TABLE_INIT_ACTION + "_ERROR";

export const FETCH_SETTINGS_QUOTANOTSET_MODAL_INIT_ACTION =
  "FETCH_SETTINGS_QUOTANOTSET_MODAL_INIT_ACTION";
export const FETCH_SETTINGS_QUOTANOTSET_MODAL_SUCCESS_ACTION =
  FETCH_SETTINGS_QUOTANOTSET_MODAL_INIT_ACTION + "_SUCCESS";
export const FETCH_SETTINGS_QUOTANOTSET_MODAL_FAIL_ACTION =
  FETCH_SETTINGS_QUOTANOTSET_MODAL_INIT_ACTION + "_ERROR";

//resetQuotaNotSet
export const FETCH_SETTINGS_QUOTANOTSET_RESET_INIT_ACTION =
  "FETCH_SETTINGS_QUOTANOTSET_RESET_INIT_ACTION";
export const FETCH_SETTINGS_QUOTANOTSET_RESET_SUCCESS_ACTION =
  FETCH_SETTINGS_QUOTANOTSET_RESET_INIT_ACTION + "_SUCCESS";
export const FETCH_SETTINGS_QUOTANOTSET_RESET_FAIL_ACTION =
  FETCH_SETTINGS_QUOTANOTSET_RESET_INIT_ACTION + "_ERROR";

//fetchSettingApartment
export const FETCH_SETTINGS_APARTMENT_INIT_ACTION =
  "FETCH_SETTINGS_APARTMENT_INIT_ACTION";
export const FETCH_SETTINGS_APARTMENT_SUCCESS_ACTION =
  FETCH_SETTINGS_APARTMENT_INIT_ACTION + "_SUCCESS";
export const FETCH_SETTINGS_APARTMENT_FAIL_ACTION =
  FETCH_SETTINGS_APARTMENT_INIT_ACTION + "_ERROR";

//updateApartment
export const ADD_SETTINGS_APARTMENT_INIT_ACTION =
  "ADD_SETTINGS_APARTMENT_INIT_ACTION";
export const ADD_SETTINGS_APARTMENT_SUCCESS_ACTION =
  ADD_SETTINGS_APARTMENT_INIT_ACTION + "_SUCCESS";
export const ADD_SETTINGS_APARTMENT_FAIL_ACTION =
  ADD_SETTINGS_APARTMENT_INIT_ACTION + "_ERROR";
//fetchSocietyTemplate

export const FETCH_SETTINGS_SOCIETY_TEMPLATE_INIT_ACTION =
  "FETCH_SETTINGS_SOCIETY_TEMPLATE_INIT_ACTION";
export const FETCH_SETTINGS_SOCIETY_TEMPLATE_SUCCESS_ACTION =
  FETCH_SETTINGS_SOCIETY_TEMPLATE_INIT_ACTION + "_SUCCESS";
export const FETCH_SETTINGS_SOCIETY_TEMPLATE_FAIL_ACTION =
  FETCH_SETTINGS_SOCIETY_TEMPLATE_INIT_ACTION + "_ERROR";

//updateSocietyAdmin
export const ADD_SETTINGS_SOCIETY_ADMIN_INIT_ACTION =
  "ADD_SETTINGS_SOCIETY_ADMIN_INIT_ACTION";
export const ADD_SETTINGS_SOCIETY_ADMIN_SUCCESS_ACTION =
  ADD_SETTINGS_SOCIETY_ADMIN_INIT_ACTION + "_SUCCESS";
export const ADD_SETTINGS_SOCIETY_ADMIN_FAIL_ACTION =
  ADD_SETTINGS_SOCIETY_ADMIN_INIT_ACTION + "_ERROR";

//updateMWReportCSetting
export const ADD_SETTINGS_REPORT_AUTO_GENERATE_INIT_ACTION =
  "ADD_SETTINGS_REPORT_AUTO_GENERATE_INIT_ACTION";
export const ADD_SETTINGS_REPORT_AUTO_GENERATE_SUCCESS_ACTION =
  ADD_SETTINGS_REPORT_AUTO_GENERATE_INIT_ACTION + "_SUCCESS";
export const ADD_SETTINGS_REPORT_AUTO_GENERATE_FAIL_ACTION =
  ADD_SETTINGS_REPORT_AUTO_GENERATE_INIT_ACTION + "_ERROR";

//fetchBillCycleDetail
export const FETCH_SETTINGS_MWRC_BILL_CYCLE_INIT_ACTION =
  "FETCH_SETTINGS_MWRC_BILL_CYCLE_INIT_ACTION";
export const FETCH_SETTINGS_MWRC_BILL_CYCLE_SUCCESS_ACTION =
  FETCH_SETTINGS_MWRC_BILL_CYCLE_INIT_ACTION + "_SUCCESS";
export const FETCH_SETTINGS_MWRC_BILL_CYCLE_FAIL_ACTION =
  FETCH_SETTINGS_MWRC_BILL_CYCLE_INIT_ACTION + "_ERROR";

//fetchSocietyprofile
export const FETCH_SETTINGS_SOCIETY_PROFILE_INIT_ACTION =
  "FETCH_SETTINGS_SOCIETY_PROFILE_INIT_ACTION";
export const FETCH_SETTINGS_SOCIETY_PROFILE_SUCCESS_ACTION =
  FETCH_SETTINGS_SOCIETY_PROFILE_INIT_ACTION + "_SUCCESS";
export const FETCH_SETTINGS_SOCIETY_PROFILE_FAIL_ACTION =
  FETCH_SETTINGS_SOCIETY_PROFILE_INIT_ACTION + "_ERROR";

//Society contact details
export const FETCH_SOCIETY_CONTACT_DETAILS_INIT_ACTION =
  "FETCH_SOCIETY_CONTACT_DETAILS_INIT_ACTION";
export const FETCH_SOCIETY_CONTACT_DETAILS_SUCCESS_ACTION =
  FETCH_SOCIETY_CONTACT_DETAILS_INIT_ACTION + "_SUCCESS";
export const FETCH_SOCIETY_CONTACT_DETAILS_FAIL_ACTION =
  FETCH_SOCIETY_CONTACT_DETAILS_INIT_ACTION + "_ERROR";

//fetchUpdateQuota
export const ADD_SETTINGS_DAILY_QUOTA_UPDATE_QUOTA_INIT_ACTION =
  "ADD_SETTINGS_DAILY_QUOTA_UPDATE_QUOTA_INIT_ACTION";
export const ADD_SETTINGS_DAILY_QUOTA_UPDATE_QUOTA_SUCCESS_ACTION =
  ADD_SETTINGS_DAILY_QUOTA_UPDATE_QUOTA_INIT_ACTION + "_SUCCESS";
export const ADD_SETTINGS_DAILY_QUOTA_UPDATE_QUOTA_FAIL_ACTION =
  ADD_SETTINGS_DAILY_QUOTA_UPDATE_QUOTA_INIT_ACTION + "_ERROR";

//fetchaptquota
export const FETCH_SETTINGS_DAILY_QUOTA_GET_QUOTA_INIT_ACTION =
  "FETCH_SETTINGS_DAILY_QUOTA_GET_QUOTA_INIT_ACTION";
export const FETCH_SETTINGS_DAILY_QUOTA_GET_QUOTA_SUCCESS_ACTION =
  FETCH_SETTINGS_DAILY_QUOTA_GET_QUOTA_INIT_ACTION + "_SUCCESS";
export const FETCH_SETTINGS_DAILY_QUOTA_GET_QUOTA_FAIL_ACTION =
  FETCH_SETTINGS_DAILY_QUOTA_GET_QUOTA_INIT_ACTION + "_ERROR";

// fetchautogeneratestatus
export const FETCH_SETTINGS_REPORT_AUTO_GENERATE_INIT_ACTION =
  "FETCH_SETTINGS_REPORT_AUTO_GENERATE_INIT_ACTION";
export const FETCH_SETTINGS_REPORT_AUTO_GENERATE_SUCCESS_ACTION =
  FETCH_SETTINGS_REPORT_AUTO_GENERATE_INIT_ACTION + "_SUCCESS";
export const FETCH_SETTINGS_REPORT_AUTO_GENERATE_FAIL_ACTION =
  FETCH_SETTINGS_REPORT_AUTO_GENERATE_INIT_ACTION + "_ERROR";

//updateSlabRate  UPDATE
export const UPDATE_SETTINGS_MWRC_SLAB_RATE_INIT_ACTION =
  "UPDATE_SETTINGS_MWRC_SLAB_RATE_INIT_ACTION";
export const UPDATE_SETTINGS_MWRC_SLAB_RATE_SUCCESS_ACTION =
  UPDATE_SETTINGS_MWRC_SLAB_RATE_INIT_ACTION + "_SUCCESS";
export const UPDATE_SETTINGS_MWRC_SLAB_RATE_FAIL_ACTION =
  UPDATE_SETTINGS_MWRC_SLAB_RATE_INIT_ACTION + "_ERROR";

//fetchSocietyContactDetail
export const FETCH_SETTINGS_REPORT_SOCIETY_CONTACT_INIT_ACTION =
  "FETCH_SETTINGS_REPORT_SOCIETY_CONTACT_INIT_ACTION";
export const FETCH_SETTINGS_REPORT_SOCIETY_CONTACT_SUCCESS_ACTION =
  FETCH_SETTINGS_REPORT_SOCIETY_CONTACT_INIT_ACTION + "_SUCCESS";
export const FETCH_SETTINGS_REPORT_SOCIETY_CONTACT_FAIL_ACTION =
  FETCH_SETTINGS_REPORT_SOCIETY_CONTACT_INIT_ACTION + "_ERROR";

//fetchApartment
export const FETCH_SETTINGS_MWRC_FETCH_APARTMENT_INIT_ACTION =
  "FETCH_SETTINGS_MWRC_FETCH_APARTMENT_INIT_ACTION";
export const FETCH_SETTINGS_MWRC_FETCH_APARTMENT_SUCCESS_ACTION =
  FETCH_SETTINGS_MWRC_FETCH_APARTMENT_INIT_ACTION + "_SUCCESS";
export const FETCH_SETTINGS_MWRC_FETCH_APARTMENT_FAIL_ACTION =
  FETCH_SETTINGS_MWRC_FETCH_APARTMENT_INIT_ACTION + "_ERROR";

//fetch Meter rent
export const FETCH_SETTINGS_METER_RENT_INIT_ACTION =
  "FETCH_SETTINGS_METER_RENT_INIT_ACTION";
export const FETCH_SETTINGS_METER_RENT_SUCCESS_ACTION =
  FETCH_SETTINGS_METER_RENT_INIT_ACTION + "_SUCCESS";
export const FETCH_SETTINGS_METER_RENT_FAIL_ACTION =
  FETCH_SETTINGS_METER_RENT_INIT_ACTION + "_ERROR";

//fetchcafdetails 
  export const FETCH_SETTINGS_CAF_INIT_ACTION =
  "FETCH_SETTINGS_CAF_INIT_ACTION";
export const FETCH_SETTINGS_CAF_SUCCESS_ACTION =
FETCH_SETTINGS_CAF_INIT_ACTION + "_SUCCESS";
export const FETCH_SETTINGS_CAF_FAIL_ACTION =
FETCH_SETTINGS_CAF_INIT_ACTION + "_ERROR";

//FETCH CAF INFO BY ID
export const FETCH_SETTINGS_CAFBYID_INIT_ACTION =
"FETCH_SETTINGS_CAFBYID_INIT_ACTION";
export const FETCH_SETTINGS_CAFBYID_SUCCESS_ACTION =
FETCH_SETTINGS_CAFBYID_INIT_ACTION + "_SUCCESS";
export const FETCH_SETTINGS_CAFBYID_FAIL_ACTION =
FETCH_SETTINGS_CAFBYID_INIT_ACTION + "_ERROR";
